"use client";

import {
	SelectArrow,
	SelectItem,
	SelectPopover,
	SelectRoot,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/Select";
import { routing, useGeo } from "@/i18n/routing";

import { Translate } from "@/components/Translate";
import type { GeoLocale } from "@frend-digital/next/i18n";
import { useRef } from "react";
import styles from "./GeoSelector.module.css";

export const LanguageForm = ({
	language,
	setLanguage,
}: { language: string; setLanguage: React.Dispatch<React.SetStateAction<string>> }) => {
	const changeLanguage = (language: string) => {
		if (!language) {
			return;
		}

		setLanguage(language);
	};

	return (
		<div>
			<div className={styles.intro}>
				<legend className={styles.title}>
					<Translate>Language</Translate>
				</legend>
				<label className={styles.languageLabel} htmlFor="language-select">
					<Translate>Select language</Translate>
				</label>
			</div>
			<SelectRoot value={language} setValue={changeLanguage}>
				<SelectTrigger id="language-select">
					<SelectValue>{(value) => <Translate>{`language.${value}`}</Translate>}</SelectValue>
					<SelectArrow />
				</SelectTrigger>
				<SelectPopover>
					{routing.languages.map((language) => (
						<SelectItem key={language} value={language}>
							<Translate>{`language.${language}`}</Translate>
						</SelectItem>
					))}
				</SelectPopover>
			</SelectRoot>
		</div>
	);
};
